export const API_SERVER_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ssZ';
export const FROM_NEWEST = true;
export const FROM_OLDEST = false;
